export enum AirdropFilterEnum {
  UPCOMING = "UPCOMING",
  AVAILABLE = "LIVE",
  ENDED = "END",
  JOINED = "JOINED",
}

export enum ProjectEnum {
  LIVE = "live",
  UPCOMING = "upcoming",
  ENDED = "ended",
}